import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/community-people-social-message-support_24877-53852.jpg';

function CommunityEngagementCenters() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Community Engagement and Resource Centers" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Community Engagement and Resource Centers</h4>
              <p>
                This sub-department is focused on fostering community connections and providing accessible resources through dedicated centers.<br />
                Services include hosting community events, providing social services, and offering spaces for educational workshops and recreational activities.<br /><br />
                By encouraging collaboration and inclusivity, we aim to strengthen community bonds and enhance quality of life for all residents.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Community Events and Gatherings</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Access to Social Services</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Educational and Recreational Programs</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to fostering a sense of community and providing essential resources that empower individuals and families to thrive.
              </p>
            </div>
            <div>
              <Link to="/department/family-services">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default CommunityEngagementCenters;
